module.exports = __webpack_public_path__ + "static/media/sofa.c6bae662.svg";